// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1x34a{padding:0 15%;min-width:100%;min-height:100vh}.ha0h7{padding:2% 0}.Hx6T9{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;min-height:100vh;min-width:100%}.Hx6T9._1WgXB .ha0h7{direction:ltr;text-align:left}.duB5S{font-size:18px}@media only screen and (max-width:850px){*{font-size:16px!important}._1x34a{padding:0 5%}.ha0h7{padding:5% 0}}", ""]);
// Exports
exports.locals = {
	"jobDescription": "_1x34a",
	"breadcrumbs": "ha0h7",
	"jobDescriptionContainer": "Hx6T9",
	"english": "_1WgXB",
	"loading": "duB5S"
};
module.exports = exports;
